import ufpr from '../assets/partners/UFPRLogo.png';
import chronion from '../assets/partners/ChronionLogo.png';
import mgm from '../assets/partners/mgm-red.png';
import projektum from '../assets/partners/projektum-red.png';
import lopes from '../assets/partners/lopes-red.png';

import cepel from '../assets/partners/cepel-red.png';
import power from '../assets/partners/power-red.png';
import avero from '../assets/partners/vero-red.png';

export const upperPartners = [
    {
        alt: 'UFPR',
        image: ufpr,
        link: 'https://ufpr.br/'
    },
    {
        alt: 'chronion',
        image: chronion,
        link: 'https://chronion.com.br/'
    },
    {
        alt: 'mgm',
        image: mgm,
        link: 'https://www.mgmdiag.com.br/'
    },
    {
        alt: 'Projektum',
        image: projektum,
        link: '*'
    },
    {
        alt: 'lopesConsultoria',
        image: lopes,
        link: 'https://lopesconsultoria.online/'
    }
]

export const lowerPartners = [
    {
        alt: 'Cepel',
        image: cepel,
        link: 'https://cepel.br/'
    },
    {
        alt: 'powermattech',
        image: power,
        link: 'https://powermattech.com/'
    },
    {
        alt: 'averodomino',
        image: avero,
        link: 'https://averodomino.com.br/'
    }
]
